import React, { useState } from 'react';
import {
    Grid, TextField, Checkbox, Box, FormControlLabel,
    Button, Typography, MenuItem, IconButton, Paper,
    useTheme,
    Divider
} from '@mui/material';
import { Delete } from '@mui/icons-material';

import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import dayjs from 'dayjs';
import 'dayjs/plugin/customParseFormat';
import { tokens } from '../../../theme/theme';
const equipmentTypes = ['Laptop', 'Mobile Phone', 'Tablet', 'Other'];



export default function EmployeeEquipmentForm({ equipmentList, setEquipmentList }) {

    const theme = useTheme();
    const colors = tokens(theme.palette.mode);

    const handleChange = (index, field, value) => {
        const updated = [...equipmentList];
        updated[index][field] = value;
        setEquipmentList(updated);
    };

    const addRow = () => {
        setEquipmentList([...equipmentList,
        {
            equipment_name: '',
            brand: '',
            model: '',
            serial_number: '',
            issued_date: null,
            return_date: null,
            status: 'Issued',
            charger_included: false,
            bag_included: false,
            mouse_included: false,
            stylus_provided: false,
            bluetooth_headset: false,
            remarks: '',
        }]);
    };


    const removeRow = (index) => {
        const updated = equipmentList.filter((_, i) => i !== index);
        setEquipmentList(updated);
    };

    return (

        <Grid container spacing={2}>

            {equipmentList.map((equipment, index) => (
                <Grid item xs={12} key={index}>
                    <Box sx={{ p: 2, backgroundColor: colors.primary[500] }}>
                        {/* elevation={3} */}
                        <Grid container spacing={2}>
                            {/* Equipment Fields */}
                            <Grid item xs={12} sm={3} lg={2} xl={2}>
                                <TextField
                                    select
                                    label="Equipment Type"
                                    fullWidth
                                    size="small"
                                    value={equipment.equipment_name}
                                    onChange={(e) => handleChange(index, 'equipment_name', e.target.value)}
                                >
                                    {equipmentTypes.map((type) => (
                                        <MenuItem key={type} value={type}>
                                            {type}
                                        </MenuItem>
                                    ))}
                                </TextField>
                            </Grid>
                            <Grid item xs={12} sm={3} lg={2} xl={2}>
                                <TextField
                                    label="Brand"
                                    size="small"
                                    fullWidth
                                    value={equipment.brand}
                                    onChange={(e) => handleChange(index, 'brand', e.target.value)}
                                />
                            </Grid>
                            <Grid item xs={12} sm={2}>
                                <TextField
                                    label="Model"
                                    size="small"
                                    fullWidth
                                    value={equipment.model}
                                    onChange={(e) => handleChange(index, 'model', e.target.value)}
                                />
                            </Grid>
                            <Grid item xs={12} sm={3} lg={2} xl={2}>
                                <TextField
                                    label="Serial Number"
                                    size="small"
                                    fullWidth
                                    value={equipment.serial_number}
                                    onChange={(e) => handleChange(index, 'serial_number', e.target.value)}
                                />
                            </Grid>
                            <Grid item xs={12} sm={2}>
                                <TextField
                                    name="issued_date"
                                    label="Issued Date"
                                    type="date"
                                    value={equipment.issued_date}
                                    onChange={(e) => handleChange(index, 'issued_date', e.target.value)}
                                    fullWidth
                                    InputLabelProps={{ shrink: true }}
                                    size="small"
                                />
                            </Grid>
                            <Grid item xs={12} sm={2}>
                                <TextField
                                    name="return_date"
                                    label="Return Date"
                                    type="date"
                                    value={equipment.return_date}
                                    onChange={(e) => handleChange(index, 'return_date', e.target.value)}
                                    fullWidth
                                    InputLabelProps={{ shrink: true }}
                                    size="small"
                                />
                            </Grid>

                            {/* Accessories Checkboxes */}
                            <Grid item xs={12} >
                                <Typography variant="subtitle2" sx={{ mb: 1 }}>
                                    Accessories Included
                                </Typography>
                                <Grid container spacing={1}>
                                    {[
                                        { label: "Charger Included", key: "charger_included" },
                                        { label: "Bag Included", key: "bag_included" },
                                        { label: "Mouse Included", key: "mouse_included" },
                                        { label: "Stylus Provided", key: "stylus_provided" },
                                        { label: "Bluetooth Headset", key: "bluetooth_headset" }
                                    ].map((item) => (
                                        <Grid item xs={12} sm={6} md={4} lg={2} key={item.key}>
                                            <FormControlLabel
                                                control={
                                                    <Checkbox
                                                        size='small'
                                                        color='secondary'
                                                        checked={equipment[item.key]}
                                                        onChange={(e) =>
                                                            handleChange(index, item.key, e.target.checked)
                                                        }
                                                    />
                                                }
                                                label={item.label}
                                            />
                                        </Grid>
                                    ))}
                                </Grid>
                            </Grid>

                            {/* Remarks and Delete */}
                            <Grid item xs={12} sm={10}>
                                <TextField
                                    label="Remarks"
                                    size="small"
                                    fullWidth
                                    multiline
                                    rows={2}
                                    value={equipment.remarks}
                                    onChange={(e) => handleChange(index, 'remarks', e.target.value)}
                                />
                            </Grid>

                            <Grid item xs={12} sm={2} display="flex" alignItems="center">
                                <IconButton
                                    onClick={() => removeRow(index)}
                                    disabled={equipmentList.length === 1}
                                >
                                    <Delete />
                                </IconButton>
                            </Grid>
                        </Grid>
                    </Box>
                </Grid>
            ))}

            <Grid item xs={12}>
                <Divider />
            </Grid>


            <Grid item xs={12}>
                <Button color="secondary" variant="outlined" onClick={addRow}>
                    + Add Equipment
                </Button>
            </Grid>
        </Grid>
    );
}


// change phase 1

// import React, { useState } from 'react';
// import {
//   Grid,
//   TextField,
//   Checkbox,
//   FormControlLabel,
//   Button,
//   Typography,
//   MenuItem,
//   IconButton,
//   Paper,
//   useTheme,
//   Accordion,
//   AccordionSummary,
//   AccordionDetails,
//   Box,
//   Dialog,
//   DialogTitle,
//   DialogActions,
// } from '@mui/material';
// import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
// import { Delete } from '@mui/icons-material';

// import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
// import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
// import { DatePicker } from '@mui/x-date-pickers/DatePicker';
// import dayjs from 'dayjs';
// import { tokens } from '../../../theme/theme';

// const equipmentTypes = ['Laptop', 'Mobile Phone', 'Tablet', 'Other'];

// export default function EmployeeEquipmentForm({ equipmentList, setEquipmentList }) {
//   const theme = useTheme();
//   const colors = tokens(theme.palette.mode);

//   // State for delete confirmation dialog
//   const [deleteConfirmOpen, setDeleteConfirmOpen] = React.useState(false);
//   const [rowToDelete, setRowToDelete] = React.useState(null);

//   const handleChange = (index, field, value) => {
//     const updated = [...equipmentList];
//     updated[index] = { ...updated[index], [field]: value };
//     setEquipmentList(updated);
//   };

//   const addRow = () => {
//     setEquipmentList([
//       ...equipmentList,
//       {
//         equipment_name: '',
//         brand: '',
//         model: '',
//         serial_number: '',
//         issued_date: null,
//         return_date: null,
//         status: 'Issued',
//         charger_included: false,
//         bag_included: false,
//         mouse_included: false,
//         stylus_provided: false,
//         bluetooth_headset: false,
//         remarks: '',
//       },
//     ]);
//   };

//   const openDeleteConfirm = (index) => {
//     setRowToDelete(index);
//     setDeleteConfirmOpen(true);
//   };

//   const closeDeleteConfirm = () => {
//     setDeleteConfirmOpen(false);
//     setRowToDelete(null);
//   };

//   const confirmDelete = () => {
//     if (rowToDelete !== null && equipmentList.length > 1) {
//       const updated = equipmentList.filter((_, i) => i !== rowToDelete);
//       setEquipmentList(updated);
//     }
//     closeDeleteConfirm();
//   };

//   return (
//     <LocalizationProvider dateAdapter={AdapterDayjs}>
//       <Box sx={{ maxWidth: '900px', margin: 'auto' }}>
//         <Typography variant="h6" gutterBottom sx={{ mb: 3, fontWeight: 'bold' }}>
//           Employee Equipment Details
//         </Typography>

//         {equipmentList.map((equipment, index) => (
//           <Accordion key={index} defaultExpanded>
//             <AccordionSummary expandIcon={<ExpandMoreIcon />}>
//               <Typography sx={{ fontWeight: 'medium' }}>
//                 {equipment.equipment_name || 'New Equipment'} - {equipment.brand || 'Brand'}
//               </Typography>
//               <Box sx={{ flexGrow: 1 }} />
//               <IconButton
//                 edge="end"
//                 color="error"
//                 onClick={(e) => {
//                   e.stopPropagation();
//                   openDeleteConfirm(index);
//                 }}
//                 disabled={equipmentList.length === 1}
//                 size="small"
//               >
//                 <Delete />
//               </IconButton>
//             </AccordionSummary>
//             <AccordionDetails>
//               <Grid container spacing={2}>
//                 {/* Equipment Type */}
//                 <Grid item xs={12} sm={6} md={4}>
//                   <TextField
//                     select
//                     label="Equipment Type"
//                     size="small"
//                     fullWidth
//                     value={equipment.equipment_name}
//                     onChange={(e) => handleChange(index, 'equipment_name', e.target.value)}
//                   >
//                     {equipmentTypes.map((type) => (
//                       <MenuItem key={type} value={type}>
//                         {type}
//                       </MenuItem>
//                     ))}
//                   </TextField>
//                 </Grid>

//                 {/* Brand */}
//                 <Grid item xs={12} sm={6} md={4}>
//                   <TextField
//                     label="Brand"
//                     size="small"
//                     fullWidth
//                     value={equipment.brand}
//                     onChange={(e) => handleChange(index, 'brand', e.target.value)}
//                   />
//                 </Grid>

//                 {/* Model */}
//                 <Grid item xs={12} sm={6} md={4}>
//                   <TextField
//                     label="Model"
//                     size="small"
//                     fullWidth
//                     value={equipment.model}
//                     onChange={(e) => handleChange(index, 'model', e.target.value)}
//                   />
//                 </Grid>

//                 {/* Serial Number */}
//                 <Grid item xs={12} sm={6} md={4}>
//                   <TextField
//                     label="Serial Number"
//                     size="small"
//                     fullWidth
//                     value={equipment.serial_number}
//                     onChange={(e) => handleChange(index, 'serial_number', e.target.value)}
//                   />
//                 </Grid>

//                 {/* Issued Date */}
//                 <Grid item xs={12} sm={6} md={4}>
//                   <DatePicker
//                     label="Issued Date"
//                     inputFormat="YYYY-MM-DD"
//                     value={equipment.issued_date ? dayjs(equipment.issued_date) : null}
//                     onChange={(newVal) => {
//                       handleChange(index, 'issued_date', newVal ? newVal.format('YYYY-MM-DD') : null);
//                     }}
//                     renderInput={(params) => (
//                       <TextField {...params} size="small" fullWidth helperText={null} />
//                     )}
//                   />
//                 </Grid>

//                 {/* Return Date */}
//                 <Grid item xs={12} sm={6} md={4}>
//                   <DatePicker
//                     label="Return Date"
//                     inputFormat="YYYY-MM-DD"
//                     value={equipment.return_date ? dayjs(equipment.return_date) : null}
//                     onChange={(newVal) => {
//                       handleChange(index, 'return_date', newVal ? newVal.format('YYYY-MM-DD') : null);
//                     }}
//                     renderInput={(params) => (
//                       <TextField {...params} size="small" fullWidth helperText={null} />
//                     )}
//                   />
//                 </Grid>

//                 {/* Accessories Checkboxes with compact grid */}
//                 <Grid item xs={12}>
//                   <Typography variant="subtitle2" gutterBottom sx={{ mb: 1, fontWeight: 'bold' }}>
//                     Accessories Included
//                   </Typography>
//                   <Grid container spacing={1}>
//                     {[
//                       { label: 'Charger Included', key: 'charger_included' },
//                       { label: 'Bag Included', key: 'bag_included' },
//                       { label: 'Mouse Included', key: 'mouse_included' },
//                       { label: 'Stylus Provided', key: 'stylus_provided' },
//                       { label: 'Bluetooth Headset', key: 'bluetooth_headset' },
//                     ].map((item) => (
//                       <Grid item xs={6} sm={3} md={1.8} key={item.key}>
//                         <FormControlLabel
//                           control={
//                             <Checkbox
//                               size="small"
//                               color="secondary"
//                               checked={!!equipment[item.key]}
//                               onChange={(e) => handleChange(index, item.key, e.target.checked)}
//                             />
//                           }
//                           label={item.label}
//                         />
//                       </Grid>
//                     ))}
//                   </Grid>
//                 </Grid>

//                 {/* Remarks */}
//                 <Grid item xs={12}>
//                   <TextField
//                     label="Remarks"
//                     size="small"
//                     fullWidth
//                     multiline
//                     rows={2}
//                     value={equipment.remarks}
//                     onChange={(e) => handleChange(index, 'remarks', e.target.value)}
//                   />
//                 </Grid>
//               </Grid>
//             </AccordionDetails>
//           </Accordion>
//         ))}

//         <Box mt={2} display="flex" justifyContent="flex-end">
//           <Button variant="outlined" color="primary" onClick={addRow}>
//             + Add Equipment
//           </Button>
//         </Box>

//         {/* Delete Confirmation Dialog */}
//         <Dialog open={deleteConfirmOpen} onClose={closeDeleteConfirm}>
//           <DialogTitle>Confirm Delete</DialogTitle>
//           <DialogActions>
//             <Button onClick={closeDeleteConfirm}>Cancel</Button>
//             <Button color="error" onClick={confirmDelete}>
//               Delete
//             </Button>
//           </DialogActions>
//         </Dialog>
//       </Box>
//     </LocalizationProvider>
//   );
// }

// change 2

// import React from "react";
// import {
//   Grid, TextField, Checkbox, FormControlLabel,
//   Button, Typography, MenuItem, IconButton,
//   Paper, Box, useTheme, Dialog, DialogTitle, DialogActions
// } from "@mui/material";
// import { Delete } from "@mui/icons-material";
// import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
// import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
// import { DatePicker } from "@mui/x-date-pickers/DatePicker";
// import dayjs from "dayjs";

// const equipmentTypes = ["Laptop", "Mobile Phone", "Tablet", "Other"];

// export default function EmployeeEquipmentForm({ equipmentList, setEquipmentList }) {
//   const [deleteIdx, setDeleteIdx] = React.useState(null);

//   const handleChange = (index, field, value) => {
//     const updated = [...equipmentList];
//     updated[index][field] = value;
//     setEquipmentList(updated);
//   };

//   const addRow = () => {
//     setEquipmentList([
//       ...equipmentList,
//       {
//         equipment_name: "",
//         brand: "",
//         model: "",
//         serial_number: "",
//         issued_date: null,
//         return_date: null,
//         status: "Issued",
//         charger_included: false,
//         bag_included: false,
//         mouse_included: false,
//         stylus_provided: false,
//         bluetooth_headset: false,
//         remarks: ""
//       }
//     ]);
//   };

//   const confirmDelete = () => {
//     setEquipmentList(equipmentList.filter((_, i) => i !== deleteIdx));
//     setDeleteIdx(null);
//   };

//   return (
//     <LocalizationProvider dateAdapter={AdapterDayjs}>
//       <Box sx={{ maxWidth: 1000, mx: "auto", p: { xs: 1, md: 2 } }}>
//         <Typography variant="h6" sx={{ fontWeight: "bold", mb: 2, textAlign: 'center' }}>
//           Employee Equipment Details
//         </Typography>
//         {equipmentList.map((equipment, idx) => (
//           <Paper
//             key={idx}
//             elevation={1}
//             sx={{ mb: 1, p: 1, background: "#F5F6FA", borderRadius: 2 }}
//           >
//             <Grid container spacing={1} alignItems="center">
//               {/* 1st Row: type, brand, model, serial, issued, return */}
//               <Grid item xs={12} sm={4} md={2.4}>
//                 <TextField select label="Type" fullWidth size="small" margin="dense"
//                   value={equipment.equipment_name}
//                   onChange={e => handleChange(idx, "equipment_name", e.target.value)}>
//                   {equipmentTypes.map(type =>
//                     <MenuItem key={type} value={type}>{type}</MenuItem>
//                   )}
//                 </TextField>
//               </Grid>
//               <Grid item xs={12} sm={4} md={2.4}>
//                 <TextField label="Brand" fullWidth size="small" margin="dense"
//                   value={equipment.brand}
//                   onChange={e => handleChange(idx, "brand", e.target.value)}
//                 />
//               </Grid>
//               <Grid item xs={12} sm={4} md={2.4}>
//                 <TextField label="Model" fullWidth size="small" margin="dense"
//                   value={equipment.model}
//                   onChange={e => handleChange(idx, "model", e.target.value)}
//                 />
//               </Grid>
//               <Grid item xs={12} sm={4} md={2.4}>
//                 <TextField label="Serial No." fullWidth size="small" margin="dense"
//                   value={equipment.serial_number}
//                   onChange={e => handleChange(idx, "serial_number", e.target.value)}
//                 />
//               </Grid>
//               <Grid item xs={6} sm={4} md={2.4}>
//                 <DatePicker label="Issued" inputFormat="YYYY-MM-DD"
//                   value={equipment.issued_date ? dayjs(equipment.issued_date) : null}
//                   onChange={newVal => handleChange(idx, "issued_date", newVal ? newVal.format("YYYY-MM-DD") : null)}
//                   renderInput={params => <TextField {...params} size="small" fullWidth margin="dense" />}
//                 />
//               </Grid>
//               <Grid item xs={6} sm={4} md={2.4}>
//                 <DatePicker label="Return" inputFormat="YYYY-MM-DD"
//                   value={equipment.return_date ? dayjs(equipment.return_date) : null}
//                   onChange={newVal => handleChange(idx, "return_date", newVal ? newVal.format("YYYY-MM-DD") : null)}
//                   renderInput={params => <TextField {...params} size="small" fullWidth margin="dense" />}
//                 />
//               </Grid>
//               {/* Accessories */}
//               {[
//                 ["charger_included", "Charger"],
//                 ["bag_included", "Bag"],
//                 ["mouse_included", "Mouse"],
//                 ["stylus_provided", "Stylus"],
//                 ["bluetooth_headset", "Bluetooth"]
//               ].map(([key, label]) =>
//                 <Grid item xs={4} sm={2.4} md={1.2} key={key}>
//                   <FormControlLabel
//                     label={label}
//                     control={
//                       <Checkbox
//                         size="small"
//                         checked={!!equipment[key]}
//                         onChange={e => handleChange(idx, key, e.target.checked)}
//                         sx={{ p: 0.5 }}
//                       />
//                     }
//                   />
//                 </Grid>
//               )}
//               {/* Remarks */}
//               <Grid item xs={12} sm={8} md={5}>
//                 <TextField
//                   label="Remarks"
//                   size="small"
//                   margin="dense"
//                   fullWidth
//                   value={equipment.remarks}
//                   onChange={e => handleChange(idx, "remarks", e.target.value)}
//                   multiline
//                   rows={1}
//                   sx={{ minHeight: 40 }}
//                 />
//               </Grid>
//               {/* Delete Button */}
//               <Grid item xs={12} sm={4} md={1} display="flex" justifyContent="flex-end" alignItems="center">
//                 <IconButton
//                   color="error"
//                   size="small"
//                   disabled={equipmentList.length === 1}
//                   onClick={() => setDeleteIdx(idx)}
//                   aria-label="Delete row"
//                 >
//                   <Delete />
//                 </IconButton>
//               </Grid>
//             </Grid>
//           </Paper>
//         ))}
//         {/* Add button */}
//         <Box mt={2} display="flex" justifyContent={{ xs: "center", sm: "flex-end" }}>
//           <Button variant="outlined" size="small" onClick={addRow}>
//             + Add Equipment
//           </Button>
//         </Box>
//         {/* Delete Confirmation */}
//         <Dialog open={deleteIdx !== null} onClose={() => setDeleteIdx(null)}>
//           <DialogTitle>Delete this equipment entry?</DialogTitle>
//           <DialogActions>
//             <Button onClick={() => setDeleteIdx(null)}>Cancel</Button>
//             <Button color="error" onClick={confirmDelete}>Delete</Button>
//           </DialogActions>
//         </Dialog>
//       </Box>
//     </LocalizationProvider>
//   );
// }


